import { MasterService } from "../services/master.service";
import config from "../config";
const {
  apiGateway: { USERS_API, APP_API },
} = config;
export const getAssistant = async (uuid,userId) => {
  try {
    return MasterService.post(`${APP_API}/genai/listassistant/id`, { uuid, userId });
  } catch (error) {
    throw error;
  }
};
export const getUsersList = async (offset, limit, id, search = '') => {
  try {
    return MasterService.post(`${APP_API}appcore/user/assistant/list`, {
        id,
        offset,
        limit,
        search,
    });
  } catch (error) {
    throw error;
  }
};
export const getPluginsList = (offset, limit, all = false) => {
  try {
    return MasterService.post(`${APP_API}appcore/plugin/list`, {
        offset,
        limit,
        all,
    });
  } catch (error) {
    throw error;
  }
};
export const addPlugin = (Data) => {
  try {
    return MasterService.post(`${APP_API}appcore/plugin/create`, Data);
  } catch (error) {
    throw error;
  }
};
export const updatePlugin = (plugin) => {
  try {
    return MasterService.put(
      `${APP_API}appcore/plugin/update/${plugin?._id}`,
      plugin
    );
  } catch (error) {
    throw error;
  }
};
export const addUser = (user) => {
  try {
    return MasterService.post(`${APP_API}appcore/users/create`, user);
  } catch (error) {
    throw error;
  }
};
export const updateUser = (user) => {
  try {
    return MasterService.post(`${APP_API}appcore/users/update`, user);
  } catch (error) {
    throw error;
  }
};
export const getOrgsList = () => {
  try {
    return MasterService.post(`${APP_API}appcore/orgs/list`);
  } catch (error) {
    throw error;
  }
};
export const updateUserPluginList = (pluginsUser) => {
  try {
    return MasterService.post(`${APP_API}appcore/plugin/mapping`, {
      emailId: pluginsUser?.emailID,
      plugins: pluginsUser?.access?.map((data) => {
        return { pluginId: data.pluginId, active: data.active };
      }),
    });
  } catch (error) {
    throw error;
  }
};
export const updateUserPlugin = (user) => {
  try {
    return MasterService.post(`${APP_API}appcore/user/assistantmapping`, user);
  } catch (error) {
    throw error;
  }
};
export const addUserForPlugin = (user) => {
  try {
    return MasterService.post(`${APP_API}appcore/users/create`, user);
  } catch (error) {
    throw error;
  }
};

export const searchUsers = (search, assistantId, tab) => {
  try {   
    return MasterService.post(`${APP_API}users/searchusers`, {
      search,
      assistantId,
      tab
    });
  } catch (error) {
    throw error;
  }
}

export const listAllUsers = () => {
  try {   
    return MasterService.post(`${APP_API}users/fetchallusers`);
  } catch (error) {
    throw error;
  }
}

export const updateUserByAdmin = (data) => {
  try {   
    return MasterService.put(`${APP_API}users/updateuser`, data);
  } catch (error) {
    throw error;
  }
}